
    <template>
      <section class="content element-doc">
        <h2>Link 文字链接</h2>
<p>文字超链接</p>
<h3>基础用法</h3>
<p>基础的文字链接用法</p>
<demo-block>
        <div><p>设置<code>type</code>属性可设置不同的状态</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;div&gt;
  &lt;apex-link&gt;默认链接&lt;/apex-link&gt;
  &lt;apex-link type=&quot;primary&quot;&gt;主要链接&lt;/apex-link&gt;
  &lt;apex-link type=&quot;success&quot;&gt;成功链接&lt;/apex-link&gt;
  &lt;apex-link type=&quot;warning&quot;&gt;警告链接&lt;/apex-link&gt;
  &lt;apex-link type=&quot;danger&quot;&gt;危险链接&lt;/apex-link&gt;
  &lt;apex-link type=&quot;info&quot;&gt;信息链接&lt;/apex-link&gt;
&lt;/div&gt;
</code></pre></template></demo-block><h3>跳转方式</h3>
<p>链接的跳转方式</p>
<demo-block>
        <div><p><code>href</code>属性为跳转网页。<code>to</code>属性为 vue-router 路由跳转，当为<code>to</code>跳转时可通过<code>params</code>传递参数</p>
</div>
        <template slot="source"><element-demo1 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;div&gt;
  &lt;apex-link type=&quot;primary&quot; href=&quot;https://baidu.com&quot; target=&quot;_blank&quot;&gt;href跳转&lt;/apex-link&gt;
  &lt;apex-link type=&quot;success&quot; to=&quot;/&quot; :params=&quot;{ name: 'wuhao', age: '18' }&quot;&gt;to跳转&lt;/apex-link&gt;
&lt;/div&gt;
</code></pre></template></demo-block><h3>禁用状态</h3>
<p>文字链接不可用状态</p>
<demo-block>
        
        <template slot="source"><element-demo2 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;div&gt;
  &lt;apex-link disabled&gt;默认链接&lt;/apex-link&gt;
  &lt;apex-link type=&quot;primary&quot; disabled&gt;主要链接&lt;/apex-link&gt;
  &lt;apex-link type=&quot;success&quot; disabled&gt;成功链接&lt;/apex-link&gt;
  &lt;apex-link type=&quot;warning&quot; disabled&gt;警告链接&lt;/apex-link&gt;
  &lt;apex-link type=&quot;danger&quot; disabled&gt;危险链接&lt;/apex-link&gt;
  &lt;apex-link type=&quot;info&quot; disabled&gt;信息链接&lt;/apex-link&gt;
&lt;/div&gt;
</code></pre></template></demo-block><h3>下划线</h3>
<p>文字链接下划线</p>
<demo-block>
        
        <template slot="source"><element-demo3 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;div&gt;
  &lt;apex-link :underline=&quot;false&quot;&gt;无下划线&lt;/apex-link&gt;
  &lt;apex-link&gt;有下划线&lt;/apex-link&gt;
&lt;/div&gt;
</code></pre></template></demo-block><h3>图标</h3>
<p>带图标的文字链接可增强辨识度</p>
<demo-block>
        
        <template slot="source"><element-demo4 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;div&gt;
  &lt;apex-link icon=&quot;el-icon-edit&quot;&gt;编辑&lt;/apex-link&gt;
  &lt;apex-link&gt;查看&lt;i class=&quot;el-icon-view el-icon--right&quot;&gt;&lt;/i&gt; &lt;/apex-link&gt;
&lt;/div&gt;
</code></pre></template></demo-block><h3>Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>type</td>
<td>类型</td>
<td>string</td>
<td>primary / success / warning / danger / info</td>
<td>default</td>
</tr>
<tr>
<td>size</td>
<td>大小</td>
<td>string</td>
<td>medium / small / mini</td>
<td>default</td>
</tr>
<tr>
<td>underline</td>
<td>是否下划线</td>
<td>boolean</td>
<td>—</td>
<td>true</td>
</tr>
<tr>
<td>disabled</td>
<td>是否禁用状态</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>href</td>
<td>原生 href 属性</td>
<td>string</td>
<td>—</td>
<td>-</td>
</tr>
<tr>
<td>to</td>
<td>vue-router路由跳转</td>
<td>string</td>
<td>—</td>
<td>-</td>
</tr>
<tr>
<td>params</td>
<td>路由跳转参数</td>
<td>object / Function</td>
<td>—</td>
<td>{}</td>
</tr>
<tr>
<td>icon</td>
<td>图标类名</td>
<td>string</td>
<td>—</td>
<td>-</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th>事件名称</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>click</td>
<td>Link 点击事件</td>
<td>—</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('apex-link',[_vm._v("默认链接")]),_vm._v(" "),_c('apex-link',{attrs:{"type":"primary"}},[_vm._v("主要链接")]),_vm._v(" "),_c('apex-link',{attrs:{"type":"success"}},[_vm._v("成功链接")]),_vm._v(" "),_c('apex-link',{attrs:{"type":"warning"}},[_vm._v("警告链接")]),_vm._v(" "),_c('apex-link',{attrs:{"type":"danger"}},[_vm._v("危险链接")]),_vm._v(" "),_c('apex-link',{attrs:{"type":"info"}},[_vm._v("信息链接")])],1)])}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('apex-link',{attrs:{"type":"primary","href":"https://baidu.com","target":"_blank"}},[_vm._v("href跳转")]),_vm._v(" "),_c('apex-link',{attrs:{"type":"success","to":"/","params":{ name: 'wuhao', age: '18' }}},[_vm._v("to跳转")])],1)])}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('apex-link',{attrs:{"disabled":""}},[_vm._v("默认链接")]),_vm._v(" "),_c('apex-link',{attrs:{"type":"primary","disabled":""}},[_vm._v("主要链接")]),_vm._v(" "),_c('apex-link',{attrs:{"type":"success","disabled":""}},[_vm._v("成功链接")]),_vm._v(" "),_c('apex-link',{attrs:{"type":"warning","disabled":""}},[_vm._v("警告链接")]),_vm._v(" "),_c('apex-link',{attrs:{"type":"danger","disabled":""}},[_vm._v("危险链接")]),_vm._v(" "),_c('apex-link',{attrs:{"type":"info","disabled":""}},[_vm._v("信息链接")])],1)])}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo3": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('apex-link',{attrs:{"underline":false}},[_vm._v("无下划线")]),_vm._v(" "),_c('apex-link',[_vm._v("有下划线")])],1)])}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo4": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('apex-link',{attrs:{"icon":"el-icon-edit"}},[_vm._v("编辑")]),_vm._v(" "),_c('apex-link',[_vm._v("查看"),_c('i',{staticClass:"el-icon-view el-icon--right"})])],1)])}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  